import yaml from "js-yaml";
import type { ToolResult } from "@/types/tools";

function formatJsonParseError(error: unknown) {
  return error instanceof Error ? error.message : "Invalid JSON input.";
}

export function formatJson(input: string, indent = 2): ToolResult<string> {
  try {
    return {
      ok: true,
      value: JSON.stringify(JSON.parse(input), null, indent),
    };
  } catch (error) {
    return {
      ok: false,
      error: formatJsonParseError(error),
    };
  }
}

export function minifyJson(input: string): ToolResult<string> {
  try {
    return {
      ok: true,
      value: JSON.stringify(JSON.parse(input)),
    };
  } catch (error) {
    return {
      ok: false,
      error: formatJsonParseError(error),
    };
  }
}

export function yamlToJson(input: string): ToolResult<string> {
  try {
    const parsed = yaml.load(input);

    return {
      ok: true,
      value: JSON.stringify(parsed ?? null, null, 2),
    };
  } catch (error) {
    return {
      ok: false,
      error: error instanceof Error ? error.message : "Invalid YAML input.",
    };
  }
}
